import { TCandidate } from 'lib/models/User.model';
import { AccomplishmentResponseAttributes } from 'lib/models/candidate';
import { parseArrayResponse } from 'lib/utils/parser';

export const getUpdateAccomplishmentValue = (
  info: AccomplishmentResponseAttributes & {
    isNew: boolean;
  }
) => {
  const { id, isNew, title, values } = info;

  const candidate: {
    accomplishments_attributes: AccomplishmentResponseAttributes[];
  } = {
    accomplishments_attributes: [
      {
        id: isNew ? '' : id,
        values,
        title,
      },
    ],
  };

  return candidate;
};

export const getSkillsInfo = (candidate: TCandidate) => {
  const accomplishmentsList =
    parseArrayResponse<AccomplishmentResponseAttributes>(
      candidate.accomplishments
    );
  const accomplishments = accomplishmentsList.map((item) => ({
    ...item,
    isNew: false,
  }));
  return accomplishments;
};
